import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ContentStyle from "styles/application/ContentStyle";
import { ReactComponent as SearchIcon } from "assets/icons/search.svg";
import useDebounce from "hooks/useDebounce";

const AC = ContentStyle();

const SearchBox = ({ value = "", onSearch, placeholder = "Search...", delay = 500, testId }) => {
	const [searchText, setSearchText] = useState(value);
	const debouncedSearchText = useDebounce(searchText, delay);
	const hasSearched = useRef(false);
	const onSearchRef = useRef(onSearch);

	useEffect(() => {}, []);

	// Keep onSearch ref updated
	useEffect(() => {
		onSearchRef.current = onSearch;
	}, [onSearch]);

	// Sync with external value prop
	useEffect(() => {
		setSearchText(value);
	}, [value]);

	useEffect(() => {
		if (debouncedSearchText.trim() !== "") {
			onSearchRef.current(debouncedSearchText);
		} else if (hasSearched.current && debouncedSearchText.trim() === "") {
			// Only trigger empty search if user has previously searched
			onSearchRef.current("");
		}
		if (debouncedSearchText.trim() !== "") {
			hasSearched.current = true;
		}
	}, [debouncedSearchText]);

	const handleChange = (e) => {
		const value = e.target.value;
		setSearchText(value);
	};

	return (
		<AC.SearchContainer>
			<AC.SearchInner className="applicationSearchBtn">
				<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
					<SearchIcon style={{ marginTop: 2 }} />
					<AC.SearchInput
						data-testid={testId}
						variant="standard"
						value={searchText}
						onChange={handleChange}
						label={placeholder}
					/>
				</div>
			</AC.SearchInner>
		</AC.SearchContainer>
	);
};

SearchBox.propTypes = {
	value: PropTypes.string,
	onSearch: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	delay: PropTypes.number,
	testId: PropTypes.string,
};

export default React.memo(SearchBox);
